 (function () {
   'use strict';
   angular.module('ShargoApp', ['ngSanitize', 'ngMaterial', 'ngAnimate', 'ngRoute', 'ngCookies', 'sahibinden.router', 'angular-google-analytics', 'google.places-custom', 'angularSlideables', 'mcApp.interpol', 'pascalprecht.translate', 'ng.deviceDetector', 'ngRateIt', 'naif.base64', 'angular-carousel-3d', 'angular-inview', 'angular-scroll-animate', 'angular-clipboard']);
 })();
